import {
  Button,
  Dialog,
  DialogActions,
  DialogContent, DialogTitle, Grid, TextField
} from "@material-ui/core";
import { useForm } from "react-hook-form";


export default function FormOnRole(props) {
  const { open, handleClose, fetchAPI } = props;
  const { register, handleSubmit, errors, } = useForm();

  const onSubmit = async (data) => {
    await fetchAPI("add", { ...data });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle id="form-dialog-title">Add On Role</DialogTitle>
          <DialogContent>
            <Grid container spacing={3}>
              {/* Name */}
              <Grid item xs={12} sm={12}>
                <TextField
                  id="nama"
                  name="nama"
                  label="Nama Role"
                  error={errors.nama}
                  fullWidth
                  placeholder="Type your Nama"
                  type="string"
                  variant="outlined"
                  autoFocus
                  inputRef={register({
                    required: {
                      value: true,
                      message: "Nama Role Tidak Boleh Kosong!",
                    },
                  })}
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    errors.nama && errors.nama.message
                  }
                />
              </Grid>

              {/* Username */}
              <Grid item xs={12} sm={12}>
                <TextField
                  id="deskripsi"
                  name="deskripsi"
                  label="Description"
                  placeholder="Type your deskripsi"
                  type="string"
                  variant="outlined"
                  error={errors.deskripsi}
                  inputRef={register({
                    required: {
                      value: true,
                      message: "Description tidak boleh kosong",
                    },
                  })}
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    errors.deskripsi && errors.deskripsi.message
                  }
                  fullWidth
                />
              </Grid>

            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="submit" color="primary">
              Add
            </Button>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
